import React, { useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { useAuth } from "../auth/AuthContext.jsx";
import { api } from "../api/client.js";
import { useLoading } from "../loading/LoadingContext.jsx";

export default function Trend() {
  const { idToken } = useAuth();
  const { start, stop } = useLoading();
  const [months, setMonths] = useState(6);
  const [trend, setTrend] = useState([]);
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    setErrorMsg(null);
    start();
    api
      .getCostTrend(idToken, months)
      .then((r) => setTrend(r.trend))
      .catch((err) => setErrorMsg(err.message))
      .finally(stop);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idToken, months]);

  return (
    <div>
      <div className="topbar">
        <h2>Consolidated trend</h2>
        <select value={months} onChange={(e) => setMonths(Number(e.target.value))}>
          {[3, 6, 12, 24].map((m) => (
            <option key={m} value={m}>
              Last {m} months
            </option>
          ))}
        </select>
      </div>
      {errorMsg && <div className="error-banner">{errorMsg}</div>}
      <div className="card" style={{ height: 360 }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={trend} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
            <CartesianGrid stroke="var(--gridline)" vertical={false} />
            <XAxis dataKey="period" tick={{ fill: "var(--ink-muted)", fontSize: 12 }} axisLine={{ stroke: "var(--border-strong)" }} tickLine={false} />
            <YAxis tick={{ fill: "var(--ink-muted)", fontSize: 12 }} axisLine={false} tickLine={false} width={60} />
            <Tooltip
              contentStyle={{ border: "1px solid var(--border)", borderRadius: 8, fontSize: 13, boxShadow: "var(--shadow-pop)" }}
              labelStyle={{ color: "var(--ink-secondary)", fontWeight: 600 }}
            />
            <Line type="monotone" dataKey="total" stroke="var(--accent-strong)" strokeWidth={2.5} dot={{ r: 3, fill: "var(--accent-strong)", strokeWidth: 0 }} activeDot={{ r: 5 }} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
